/*
  Opens the EU energy-label popup for Bloomreach product cards.

  The widget renders its cards inside a shadow root, so the theme's
  <basic-modal> cannot be used from inside a card: its `controls` getter runs
  document.querySelectorAll('[aria-controls="..."]'), which does not cross a
  shadow boundary, so the trigger would never be wired up.

  Click events are composed, though, so they do escape the shadow root and
  reach the document — we listen there, walk composedPath() to find the badge
  that was clicked, and show one shared modal that lives in the light DOM
  (where theme.css applies and the drawer markup behaves exactly as on the
  PLP). The card template only has to render the badge with
  data-br-energy-label pointing at the label image.

  Companion to bloomreach-product-card-hover.js, which reaches into the same
  shadow roots for the swatch hover behaviour.
*/
(function () {
  'use strict';

  var MODAL_ID = 'EnergyLabelModal-br-shared';
  var TRIGGER_CLASS = 'energy-class-popup';

  var CLOSE_LABELS = {
    nl: 'Sluiten',
    fr: 'Fermer',
    de: 'Schließen',
    en: 'Close',
  };

  function closeLabel() {
    var lang = (document.documentElement.getAttribute('lang') || 'nl').toLowerCase().split('-')[0];
    return CLOSE_LABELS[lang] || CLOSE_LABELS.nl;
  }

  // Built once, reused by every card. innerHTML is set before the element is
  // appended so the overlay and close button are already present when
  // connectedCallback collects them as controls.
  function getModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    var modal = document.createElement('basic-modal');
    modal.id = MODAL_ID;
    modal.className = 'drawer modal energy-popup';
    modal.style.setProperty('--modal-width', '77rem');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fixed-overlay" aria-controls="' +
      MODAL_ID +
      '"></div>' +
      '<div class="drawer__inner color-scheme-1">' +
      '<button class="drawer__close-btn" aria-controls="' +
      MODAL_ID +
      '" aria-label="' +
      closeLabel() +
      '">' +
      '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium icon--thick" fill="none" viewBox="0 0 24 24"><use href="#icon-close"/></svg>' +
      '</button>' +
      '<div class="drawer__body v-scrollable h-full">' +
      '<div class="rte"><img data-energy-label-image alt="" loading="lazy" decoding="async"></div>' +
      '</div>' +
      '</div>';

    document.body.appendChild(modal);
    return modal;
  }

  function show(src, alt, trigger) {
    if (!window.customElements) return;

    customElements.whenDefined('basic-modal').then(function () {
      var modal = getModal();
      var image = modal.querySelector('img[data-energy-label-image]');

      if (image) {
        image.setAttribute('src', src);
        image.setAttribute('alt', alt || '');
      }

      if (typeof modal.show === 'function') {
        modal.show(trigger);
      } else {
        modal.setAttribute('open', '');
      }
    });
  }

  function triggerFromEvent(event) {
    var path = event.composedPath ? event.composedPath() : [event.target];

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node === document || node === window) break;
      if (node && node.classList && node.classList.contains(TRIGGER_CLASS)) return node;
    }

    return null;
  }

  // Capture phase: the widget has its own delegated click handling for cards,
  // and stopping propagation here keeps a badge click from being treated as a
  // card click.
  document.addEventListener(
    'click',
    function (event) {
      var trigger = triggerFromEvent(event);
      if (!trigger) return;

      // Theme cards use the same class but wire themselves up through
      // aria-controls, so leave those alone.
      if (trigger.hasAttribute('aria-controls')) return;

      var src = trigger.getAttribute('data-br-energy-label');
      if (!src || trigger.hasAttribute('disabled')) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      show(src, trigger.getAttribute('data-br-energy-alt'), trigger);
    },
    true
  );
})();
